import { put } from "../../common/api/apiShared";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { ITogglePreselectedOnCreateDialogProps } from "./TogglePreselectedOnCreateDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { useTranslation } from "../../localization/useTranslation";

export function useTogglePreselectedOnCreateDialog(props: ITogglePreselectedOnCreateDialogProps) {
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();

    const toggleMutation = useDotLegalMutation(togglePreselected);

    const toggle = () => {
        toggleMutation.mutateAsync(undefined, {
            onSuccess: () => {
                snackbar.show(props.isPreselectedOnCreate ? translateString("removeAsPreselectedOnCreate") : translateString("setAsPreselectedOnCreate"));
                props.onUpdate();
                props.onCloseDialog();
            },
        });
    };

    function togglePreselected() {
        return put<{}>(`/LegalEntity/${props.legalEntityId}/toggle-preselected-on-create?isPreselected=${!props.isPreselectedOnCreate}`, undefined);
    }

    return {
        toggle,
        isSaving: toggleMutation.isLoading,
    };
}
